import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthProvider";
import { LanguageProvider } from "./context/LanguageContext";
import { UserProvider } from "./context/UserContext";
import { BrandConfigProvider } from "./context/BrandConfigContext";
import { StoreDataProvider } from "./context/StoreDataContext";
import { LayoutPreferencesProvider } from "./context/LayoutPreferencesContext";
import { StoreCacheProvider } from "./context/StoreCacheContext";
import { StoreListProvider } from "./context/StoreListContext";
import AppThemeProvider from "./theme/AppThemeProvider";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <LanguageProvider>
    <AuthProvider>
      <UserProvider>
        <BrandConfigProvider>
          <StoreDataProvider>
            <StoreCacheProvider>
              <StoreListProvider>
                <LayoutPreferencesProvider>
                  <AppThemeProvider>
                    <App />
                    <ToastContainer
                      position="top-right"
                      autoClose={4000}
                      hideProgressBar={false}
                      newestOnTop
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss={false}
                      draggable
                      theme="light"
                      style={{ top: '80px' }}
                      toastClassName="custom-toast"
                      limit={3}
                    />
                  </AppThemeProvider>
                </LayoutPreferencesProvider>
              </StoreListProvider>
            </StoreCacheProvider>
          </StoreDataProvider>
        </BrandConfigProvider>
      </UserProvider>
    </AuthProvider>
  </LanguageProvider>
);